import { useTranslation } from 'react-i18next';
import {
  TeModal,
  TeContainer,
  TeContainerSlim,
  TeButton,
  TeText,
  TeIcon,
} from '@topcon/tuicl-react';

import IconWrapper from '../../../components/IconWrapper';
import { background } from '../../../providers/theme/theme.index';

interface Props {
  open: boolean;
  onClose: () => void;
}

function NoVerifiedDomainsModal({ open, onClose }: Props) {
  const { t } = useTranslation(['settings', 'common']);

  return (
    <TeModal
      variant="dark"
      open={open}
      closeMode="overlay"
      teclose={onClose}
      contentPadding={0}
      size="s"
      width="s"
    >
      <TeContainer
        backgroundColor="background.primary"
        padding={['xl', 's']}
        column
        grow
        alignItems="center"
      >
        <IconWrapper size={64} backgroundColor={background.tertiary} noOutline>
          <TeIcon size="xl" name="portrait" />
        </IconWrapper>
        <TeContainerSlim column alignItems="center" gap="l">
          <TeContainerSlim column alignItems="center" gap="xs2">
            <TeText size={20} weight={700}>
              {t('identityProviderCannotBeAddedTitle')}
            </TeText>
            <TeText size={12} color="text.secondary">
              {t('identityProviderCannotBeAddedDescription')}
            </TeText>
          </TeContainerSlim>
          <TeButton
            text={t('iUnderstand', { ns: 'common' })}
            variant="primary"
            teclick={onClose}
            size="s"
          />
        </TeContainerSlim>
      </TeContainer>
    </TeModal>
  );
}

export default NoVerifiedDomainsModal;
